import { __extends } from "tslib";
import { Container } from 'inversify';
import { ServiceIdentifier } from './ServiceIdentifier';
import NeoTypes from './NeoTypes';
var NeoContainer = /** @class */ (function (_super) {
    __extends(NeoContainer, _super);
    function NeoContainer(containerOptions) {
        return _super.call(this, containerOptions) || this;
    }
    /** Binds a service to a type. */
    NeoContainer.prototype.bind = function (serviceId) {
        var symbol = (serviceId instanceof ServiceIdentifier) ? serviceId.symbol : serviceId;
        if (this.isBound(symbol)) {
            return _super.prototype.rebind.call(this, symbol);
        }
        else {
            return _super.prototype.bind.call(this, symbol);
        }
    };
    /** Binds a service to a type only if the type has no services bound to it. */
    NeoContainer.prototype.bindIfMissing = function (serviceId, whenMissing) {
        if (!this.isBound(serviceId.symbol)) {
            whenMissing(this.bind(serviceId));
        }
    };
    /** Binds a config identifier to a section in the main app config. */
    NeoContainer.prototype.bindConfig = function (serviceId, selector) {
        _super.prototype.bind.call(this, serviceId.symbol).toDynamicValue(function (c) {
            return selector(c.container.get(NeoTypes.Config.ConfigModel.symbol));
        }).inSingletonScope();
    };
    NeoContainer.prototype.get = function (symbolOrSid) {
        if (symbolOrSid instanceof ServiceIdentifier) {
            return _super.prototype.get.call(this, symbolOrSid.symbol);
        }
        else {
            return _super.prototype.get.call(this, symbolOrSid);
        }
    };
    return NeoContainer;
}(Container));
export { NeoContainer };
